import React from "react";
import { useLocation } from "react-router-dom";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"; //,localAuthCheck
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { setIsStoreActive } from "../Redux/features/NavBar/MenuSlice";
import { SECRET_KEY } from "../Constants/Config";
import { clearPersistedSessionLoginId } from "../Common/persistedLoginId";

export default function ProtectedRoute(props) {
  const dispatch = useDispatch();
  const location = useLocation();

  const { permissionPresetData } = useSelector(
    (state) => state.permissionPreset
  );
  let AuthSessionRecord =
    Cookies.get("token_data") !== undefined ? Cookies.get("token_data") : [];
  let authdecryptRecord = CryptoJS.AES.decrypt(
    AuthSessionRecord,
    SECRET_KEY
  ).toString(CryptoJS.enc.Utf8);
  const AdminRocord =
    authdecryptRecord !== ""
      ? JSON.parse(authdecryptRecord)
      : { status: false };
  const handleClearCoockie = () => {
    Cookies.remove("loginDetails");
    Cookies.remove("user_auth_record");
    Cookies.remove("token_data");
    Cookies.remove("superadmin_details");
    clearPersistedSessionLoginId();
    // localStorage.removeItem("AllStore");
    try {
      localStorage.removeItem("permissionPresetData");
    } catch (e) {}
  };

  if (
    AdminRocord?.status == true &&
    AdminRocord?.login_type == "superadmin" &&
    props.visible == "superadmin" &&
    // AdminRocord?.data?.merchant_id == ""
    (AdminRocord?.data?.merchant_id == "" || location?.state?.backToSuperAdmin)
  ) {
    // console.log("ok 1");
    dispatch(setIsStoreActive(false));
    return <Outlet />;
  } else if (
    AdminRocord?.status == true &&
    AdminRocord?.login_type == "superadmin" &&
    props.visible == "superadmin" &&
    AdminRocord?.data?.merchant_id !== ""
  ) {
    // console.log("ok 2");
    dispatch(setIsStoreActive(true));
    // return <Outlet />;
    return <Navigate to="/" />;
  } else if (
    AdminRocord?.status == true &&
    (AdminRocord?.login_type == "superadmin" ||
      AdminRocord?.data?.login_type == "manager" ||
      AdminRocord?.data?.login_type == "cashier" ||
      AdminRocord?.data?.login_type == "driver" ||
      AdminRocord?.data?.login_type == "time_clock_only" ||
      AdminRocord?.data?.login_type == "merchant" ||
      AdminRocord?.data?.login_type == "admin" ||
      AdminRocord?.login_type == "merchant" ||
      AdminRocord?.login_type == "manager" ||
      AdminRocord?.login_type == "cashier" ||
      AdminRocord?.login_type == "driver" ||
      AdminRocord?.login_type == "time_clock_only" ||
      AdminRocord?.login_type == "admin") &&
    (props.visible == "cashier" ||
      props.visible == "manager" ||
      props.visible == "driver" ||
      props.visible == "time_clock_only") &&
    (AdminRocord?.data?.merchant_id !== "" ||
      AdminRocord?.data?.merchant_id == "no_id") &&
    AdminRocord?.data?.merchant_id !== undefined
  ) {
    // console.log("ok 3");
    dispatch(setIsStoreActive(true));
    return <Outlet />;
  } else if (
    AdminRocord?.status == true &&
    AdminRocord?.login_type == "superadmin" &&
    props.visible == "manager" &&
    AdminRocord?.data?.merchant_id == ""
  ) {
    return <Navigate to="/users/unapprove" />;
  } else {
    // console.log("ok 4");
    const userLoginType =
      AdminRocord?.data?.login_type || AdminRocord?.login_type;
    const userPermission = permissionPresetData?.find(
      (item) => item?.preset_name === userLoginType
    );

    if (userPermission) {
      dispatch(setIsStoreActive(true));
      return <Outlet />;
    } else {
      handleClearCoockie();
      dispatch(setIsStoreActive(false));
      return <Navigate to="/login" />;
    }
  }
}
